import { useContext, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import applyFormat from '../functions/applyFormat';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditPayoutInfoModal = () =>{
    const {
        editPayoutInfoModal, 
        setEditPayoutInfoModal,  
        editPayoutInfoRow,
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        payoutInfoConfig, 
        payoutInfoLists
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT, 
    } = useContext(HttpContext);
    // get global state
    const company = useSelector((state) => state.company);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    // initialize state for master setup
    const [showAchInfo, setShowAchInfo] = useState(true); 
    const [commentText, setCommentText] = useState('');

    // check whether ach type will clear ach info. If clears info return false so ach info does not show on modal
    const checkShowAchInfo = (method) => {
        // find method in payoutInfoLists['payoutmethodid']
        for (let i = 0; i < payoutInfoLists['payoutmethodid'].length; i++){
            if (payoutInfoLists['payoutmethodid'][i]['id'].toString() === method['id'].toString()){
                // return !clearachinfo to determine whether it should be shown in modal 
                return !payoutInfoLists['payoutmethodid'][i]['clearachinfo']; 
            }
        }
        // default return is true 
        return true; 
    }

    // event handler for values change 
    const onInputChange = () => {
        console.log(values); 
        // check whether to show payout information 
        if (values['payoutmethodid'] && !checkShowAchInfo(values['payoutmethodid'])) {
            setShowAchInfo(showAchInfo => showAchInfo = false); 
        }
        else {
            setShowAchInfo(showAchInfo => showAchInfo = true); 
        }
    }

    const onSubmitClick = () =>{ 
        console.log('PAYOUTMETHOD: ', values['payoutmethodid']); 
        return new Promise((resolve, reject) => {
            // get oldValues to compare
            let temp = {...editPayoutInfoRow}
            let oldValues = applyFormat(temp, payoutInfoConfig, payoutInfoLists, null); 

            // check if any ACH fields changed
            // note: values['payoutmethodid'] is an object {id, label} from dropdown, so compare id
            const achFields = ['achaccountnumber', 'achbankabanumber', 'achaccounttype'];
            const achFieldsChanged = achFields.some(f => values[f] !== oldValues[f]) || 
                (values['payoutmethodid'] && oldValues['payoutmethodid'] && values['payoutmethodid']['id'] !== oldValues['payoutmethodid']['id']);

            // validate comment input ONLY if ACH fields changed
            if (achFieldsChanged && (!commentText || commentText.trim() === '')) {
                snackbarAlert(true, 'Please enter a comment.', 'error');
                reject();
                return;
            }
            let requestValues = [{...values}]; 
            let dynamicArgs = { 
                achaccountnumber: {
                    clearachinfo: values['payoutmethodid']['clearachinfo']
                },
                achbankabanumber: {
                    clearachinfo: values['payoutmethodid']['clearachinfo']
                },
                achaccounttype: {
                    clearachinfo: values['payoutmethodid']['clearachinfo']
                }
            } 
            // validate array 
            let checkError = validateInputArray(
                requestValues, 
                payoutInfoConfig,
                dynamicValidation,
                {
                    ...payoutInfoLists, 
                    companyid: {
                        override: false, 
                        list: [...payoutInfoLists['companyid'], process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER]
                    }
                }, 
                snackbarAlert,  
                error, 
                setError, 
                (row, config, args) => {
                    // run transformation on row 
                    let temp = dynamicTransformation(row, config, args); 
                    // remove index
                    delete temp['mastersetupbool']; 
                    // return transformed row 
                    return temp; 
                }, 
                dynamicArgs
            ); 
            // don't run request if error
            if (checkError) {
                reject(); 
                return; 
            }
            // add mastercompanyid to request body 
            requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid']; 
            requestValues[0]['companyid'] = editPayoutInfoRow['companyid']; 
            // get oldValues to attach to request 
            oldValues = dynamicTransformation(oldValues, payoutInfoConfig, dynamicArgs); 
            // use PUT function to make request
            let response; 
            console.log('REQUEST: ', requestValues[0]); 
            PUT('/client/payoutInfo', {
                ...requestValues[0], 
                oldValues: oldValues,
                comment: commentText.trim()
            }).then(res => {  
                console.log(res); 
                response = res; 
                // hide modal 
                setEditPayoutInfoModal(editPayoutInfoModal => editPayoutInfoModal = false);
                // reset comment text
                setCommentText('');
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh company details page using function from parent
                return getRefreshData();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    
    // useEffect to run on config change 
    useEffect(() => {
        if (payoutInfoConfig){
            setConfig(config => config = payoutInfoConfig); 
        }
    }, [payoutInfoConfig]); 

    // useEffect to run on editPayoutInfoRow change
    useEffect(() => {
        if (editPayoutInfoRow) {
            console.log(editPayoutInfoRow); 
            // add ids to lookup values 
            let temp = {
                ...editPayoutInfoRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, payoutInfoConfig, payoutInfoLists, null); 
            // find method in payoutInfoLists['payoutmethodid']
            if (temp['active']){
                for (let i = 0; i < payoutInfoLists['payoutmethodid'].length; i++){
                    if (payoutInfoLists['payoutmethodid'][i]['id'].toString() === temp['active']['id'].toString()){
                        // return !clearachinfo to determine whether it should be shown in modal 
                       setShowAchInfo(showAchInfo => showAchInfo = !payoutInfoLists['payoutmethodid'][i]['clearachinfo']); 
                    }
                }
            }
            // set state 
            setValues(values => values = temp); 
        }
    }, [editPayoutInfoRow]); 

    const handleCloseModal = () => {
        setEditPayoutInfoModal(false);
        setCommentText('');
    };

    return(
        <> 
            <CCOffcanvas
                title={`Edit Payout Info for ${editPayoutInfoRow['companyname']}`}
                show={editPayoutInfoModal}  
                onCanvasClose={handleCloseModal}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >   
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {config.map((el) => 
                                el['edit'] == true &&
                                (!['achaccountnumber', 'achbankabanumber', 'achaccounttype'].includes(el['columnid']) || showAchInfo) ? // logic for showing achinfo
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={payoutInfoLists} 
                                            width={'100%'} 
                                            showError={error[0][el['columnid']]}
                                            onChangeFunction={onInputChange}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                : <></>
                            )}
                        <div>
                            <div className="comment-section" style={{"border-radius": "8px", padding : "2px"}}>
                                <div className="bg-white comment-card" >
                                        {/* textarea input for new comment */}
                                        <div className="p-3">
                                            <div className="offcanvas-details pb-3" style={{ fontSize: '14px' }}>
                                                Comment
                                            </div>
                                            <input className="w-100 input-text-field" value={commentText} onChange={(e) => setCommentText(commentText => commentText = e.target.value)} placeholder='Type comments here'></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* button to submit sub company */}
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={handleCloseModal}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick} />
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default EditPayoutInfoModal;